@for (document of tableData; track document) {
  <div class="d-flex align-items-center justify-content-center accordion-mobile-item">
    <div class="ps-3 w-100 align-items-center justify-content-center">
      <span class="lato-font">{{document.name}}</span><br />
      <!-- <span class="text-secondary mobile-text" translate="Request.Document.{{document.documentType}}"></span> -->
    </div>
    <div class="col-1">
      <span class="float-end">
        <button type="button" (click)="$event.stopPropagation();" class="btn bg-transparent border-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi bi-three-dots"></i>
        </button>
        <ul class="dropdown-menu">
          @if (openPreviewAllowed() && document.documentType !== 'JsonSignature' && isPossibleToViewRendering(document)) {
            <li>
              <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.OpenPreview, null, document.identifier)"
              translate="Button.ShowDocument"></a>
            </li>
          }
          <li>
            <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.showDocumentDetails, null, document.identifier)"
            translate="Button.ShowDocumentDetails"></a>
          </li>
        </ul>
      </span>
    </div>
  </div>
  <!-- Display data and declare specific embedded component -->
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"
    [ngClass]="{'cursor-pointer': openPreviewDocumentAllowed(row)  }"
    (click)="openPreviewDocumentAllowed(row) ? performActionForAnId(requestStatusActionsEnum.OpenPreview, null, row.identifier) : null">
  </tr>
}